import { Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import { MainButton, MainButtons } from "../../../../components/button";
import useCompetition from "../../../../hooks/useCompetition";
import useCurrentUser from "../../../../hooks/useCurrentUser";
import useLocation from "../../../../hooks/useLocation";
import Panel from "../Panel";
import { Heading, Intro } from "../Typography";

const JudgeKidsScreen = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { competition } = useCompetition(params.competitionUUID);
  const { profile, isValidating: isProfileValidating } = useCurrentUser();
  const location = useLocation<{ didJustRegister: boolean }>();
  const didJustRegister = location.state?.didJustRegister;

  return (
    <Panel>
      <Heading size="small">
        Would you like to register any competitors?
      </Heading>
      {!competition || (!profile && isProfileValidating) ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <Intro>If you’re just judging, select no and continue.</Intro>
          <MainButtons>
            <MainButton
              variant="outline-primary"
              onClick={() =>
                navigate(`/${params.competitionUUID}/enter/competitors`, {
                  state: { isJudge: true },
                })
              }
            >
              Yes
            </MainButton>
            <MainButton
              variant="primary"
              onClick={() =>
                navigate("../confirm", { state: { didJustRegister } })
              }
            >
              No
            </MainButton>
          </MainButtons>
        </>
      )}
    </Panel>
  );
};

export default JudgeKidsScreen;
